<template>
  <v-card>
    <v-card-title style="padding: 1rem">
      <h3>Filtri</h3>
    </v-card-title>
    <v-divider />
    <v-card-text>
      <v-col>
        <v-row>
          <v-col>
            <v-switch
              v-model="filters.inStock"
              inset
              label="Disponibili"
            ></v-switch>
          </v-col>
          <v-col>
            <v-switch
              v-model="filters.notInStock"
              inset
              label="Terminati"
            ></v-switch>
          </v-col>
        </v-row>
      </v-col>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-btn
        color="orange"
        style="margin: 0.5rem 0.5rem 0.5rem auto"
        @click="this.filters = {
          inStock: true,
          notInStock: false,
        }"
      >Reset filtri</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  import { mapMutations, mapGetters } from 'vuex'

  export default {
    name: 'Filters',
    data() {
      return {
        filters: {
          inStock: true,
          notInStock: false,
        }
      }
    },

    watch: {
      filters: {
        handler(val) {
          this.$emit('filters-changed', val)
        },
        deep: true,
        immediate: true
      }
    }
  }
</script>

<style>
</style>